document.addEventListener("DOMContentLoaded", async function () {
  const mapElement = document.getElementById("contact-google-map");

  if (!mapElement) return;

  try {
    await loadLeaflet();

    const address = mapElement.dataset.address;

    const map = L.map(mapElement, {
      zoomControl: true
    });

    L.tileLayer("https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png", {
      attribution: "&copy; OpenStreetMap contributors",
      maxZoom: 19
    }).addTo(map);

    fetch(
      `https://nominatim.openstreetmap.org/search?format=json&q=${encodeURIComponent(address)}`
    )
      .then(res => res.json())
      .then(data => {
        if (!data.length) {
          console.error("Address not found:", address);
          return;
        }

        const lat = parseFloat(data[0].lat);
        const lon = parseFloat(data[0].lon);

        map.setView([lat, lon], 15);
   const customIcon = L.divIcon({
  className: "custom-map-marker",
  html: `
    <svg xmlns="http://www.w3.org/2000/svg" width="40" height="35" viewBox="0 0 24 24" aria-hidden="true">
      <path d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7z"
        fill="#fd3d00"
        stroke="#222222"
        stroke-width="1"/>
    </svg>
  `,
  iconSize: [20, 28],
  iconAnchor: [10, 28],
  popupAnchor: [0, -28]
});

L.marker([lat, lon], {
  icon: customIcon
}).addTo(map);

L.marker([lat, lon], {
  icon: customIcon
}).addTo(map);

        setTimeout(() => map.invalidateSize(), 100);
      });

  } catch (err) {
    console.error("Failed to load Leaflet:", err);
  }
});

function loadLeaflet() {
  return new Promise(function (resolve, reject) {
    if (window.L) {
      resolve(window.L);
      return;
    }

    // Load CSS only once
    if (!document.querySelector('link[data-leaflet]')) {
      const css = document.createElement('link');
      css.rel = 'stylesheet';
      css.href = 'https://unpkg.com/leaflet@1.9.4/dist/leaflet.css';
      css.setAttribute('data-leaflet', 'true');
      document.head.appendChild(css);
    }

    // Load JS only once
    const existingScript = document.querySelector('script[data-leaflet]');
    if (existingScript) {
      existingScript.addEventListener('load', () => resolve(window.L));
      existingScript.addEventListener('error', reject);
      return;
    }

    const script = document.createElement('script');
    script.src = 'https://unpkg.com/leaflet@1.9.4/dist/leaflet.js';
    script.defer = true;
    script.setAttribute('data-leaflet', 'true');

    script.onload = () => resolve(window.L);
    script.onerror = reject;

    document.head.appendChild(script);
  });
}